module.exports = __webpack_public_path__ + "img/placenta-complete.762a5994.png";